import * as z from "zod";
import { null as zNull } from "zod";

export const reorderParcels = {
  name: "reorderParcels" as const,
  input: z.object({
    parcels: z.array(z.object({ name: z.string(), position: z.number() })),
  }),
  output: zNull(),
};
